<template>
  <div>
    <b-field v-if="!this.user.loggedIn" label="Email">
      <b-input v-model="form.email" ref="email" type="email"></b-input>
    </b-field>

    <b-field v-if="!this.user.loggedIn" label="WeChat">
      <b-input v-model="form.wechat" ref="wechat"></b-input>
    </b-field>

    <b-field label="Product Link (ONLY AMAZON.IT LINK ALLOWED - NO SHORT LINKS)">
      <b-input ref="link" v-model="form.link" type="url" required></b-input>
    </b-field>

    <b>Discount type</b><br /><br />
    <b-field>
      <b-radio v-model="discountType" name="name" native-value="code">
        Discount code (<a
          href="https://i.ibb.co/3Yb25cs/Screenshot-2022-09-23-at-13-39-51.png"
          target="_blank"
          >example</a
        >)
      </b-radio>
      <b-radio v-model="discountType" name="name" native-value="coupon">
        Coupon checkout (<a
          href="https://i.ibb.co/jR69dYk/Screenshot-2022-09-23-at-13-38-47.png"
          target="_blank"
          >example</a
        >)
      </b-radio>
      <b-radio v-model="discountType" name="name" native-value="both">
        Both (discount code + coupon checkout)
      </b-radio>
    </b-field>

    <b-field label="Discount code" v-if="discountType === 'code' || discountType === 'both'">
      <b-input ref="coupon" v-model="form.coupon" required></b-input>
    </b-field>

    <b-field label="Coupon checkout (% or € savings)" v-if="discountType === 'coupon' || discountType === 'both'">
      <div style="display: flex">
        <b-input
          type="number"
          step="0.01"
          ref="promo"
          v-model="form.checkout"
          required
        ></b-input>
        <b-select placeholder="" v-model="unitCheckout">
          <option v-for="option in ['%', '€']" :value="option" :key="option">
            {{ option }}
          </option>
        </b-select>
      </div>
    </b-field>

    <div class="columns">
      <div class="column">
        <b-field label="Original Price">
          <b-input
            ref="originalPrice"
            v-model="form.originalPrice"
            required
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Discounted Price">
          <b-input ref="newPrice" v-model="form.newPrice" required></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="From">
          <b-datetimepicker
            v-model="form.dateFrom"
            rounded
            placeholder="Click to select..."
            icon="calendar-today"
            :datepicker="{ showWeekNumber: false }"
            :timepicker="{ enableSeconds: false, hourFormat: '24' }"
            required
          ></b-datetimepicker>
        </b-field>
      </div>
      <div class="column">
        <b-field label="To">
          <b-datetimepicker
            v-model="form.dateTo"
            rounded
            placeholder="Click to select..."
            icon="calendar-today"
            :datepicker="{ showWeekNumber: false }"
            :timepicker="{ enableSeconds: false, hourFormat: '24' }"
            required
          ></b-datetimepicker>
        </b-field>
      </div>
    </div>
    <div class="buttons is-pulled-right">
      <b-button type="is-primary" :disabled="sendDisabled" @click="submitForm"
        >Submit</b-button
      >
      <b-button type="is-light" @click="resetForm">Reset</b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "firebase";

const form = {
  email: "",
  wechat: "",
  link: "",
  coupon: "",
  checkout: "",
  priceDrop: "",
  originalPrice: "",
  newPrice: "",
  dateFrom: undefined,
  dateTo: undefined,
};
export default {
  name: "CouponForm",
  props: {
    msg: String,
  },
  data() {
    return {
      form: Object.assign({}, form),
      sendDisabled: false,
      discountType: null,
      unitCheckout: null,
    };
  },
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: "user",
    }),
  },
  methods: {
    validate() {
      let isValid = true;
      if (!this.user.loggedIn) {
        isValid =
          this.$refs.email.checkHtml5Validity() &&
          this.$refs.wechat.checkHtml5Validity();
      }

      isValid =
        isValid &&
        this.$refs.link.checkHtml5Validity() &&
        this.form.link.includes('amazon.it') &&
        this.$refs.originalPrice.checkHtml5Validity() &&
        this.$refs.newPrice.checkHtml5Validity() &&
        this.discountType &&
        this.form.dateFrom &&
        this.form.dateTo &&
        this.form.coupon || (this.form.checkout && this.unitCheckout)

      return isValid;
    },
    async submitForm() {
      this.sendDisabled = true;
      const db = firebase.firestore();
      const isFormValid = this.validate();

      // const existingCoupons = await db
      //   .collection("deals")
      //   .where("uid", "==", this.user.data.uid)
      //   .where("coupon", "==", this.form.coupon)
      //   .where("status", "==", "pending")
      //   .get();

      // if (existingCoupons.docs.length > 0) {
      //   this.$buefy.notification.open({
      //     message: `Coupon ${this.form.coupon} already sent`,
      //     type: "is-danger",
      //     hasIcon: true,
      //   });
      //   return;
      // }

      if (isFormValid) {
        db.collection("deals")
          .add({
            email: this.user.data.email,
            uid: this.user.data.uid,
            link: this.form.link,
            coupon: this.form.coupon,
            checkout: this.form.checkout,
            unitCheckout: this.unitCheckout,
            discountType: this.discountType,
            originalPrice: this.form.originalPrice,
            newPrice: this.form.newPrice,
            dateFrom: this.form.dateFrom,
            dateTo: this.form.dateTo,
            sent: new Date(),
            status: "pending",
          })
          .then(() => {
            console.log("Document successfully written!");
            this.$buefy.notification.open({
              message: "Coupon code sent to our staff successfully",
              type: "is-success",
              hasIcon: true,
            });
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
            this.$buefy.notification.open({
              message: "Error sending data",
              type: "is-danger",
              hasIcon: true,
            });
          });

        this.resetForm();
      } else {
        this.$buefy.notification.open({
          message: "Please fill all fields or check fields content",
          type: "is-warning",
          hasIcon: true,
        });
      }
      this.sendDisabled = false;
    },
    resetForm() {
      this.form = form;
    },
  },
};
</script>
